export default __webpack_public_path__ + "static/media/important-big.4b4718c4.svg";